/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React from "react"
import { useSelector } from "react-redux"
import { SingleCategoryReimbursementsList } from "./company-plan-config-type/SingleCategoryList"
import { MultipleCategoriesReimbursementsLists } from "./company-plan-config-type/MultipleCategoriesReimbursementsLists"
import { getSubsidies } from "#/redux/reducers/subsidies"
import { useReimbursements } from "#/services/user/hooks/useReimbursements"

interface ReimbursementsListProps {
  onTransactionClick?: (transaction: any) => void
}

const ReimbursementsList: React.FC<ReimbursementsListProps> = ({ onTransactionClick }) => {
  const { data: reimbursementsList } = useReimbursements()

  const subsidies = useSelector(getSubsidies)
  const hasMultipleCategories = subsidies?.length > 1

  return (
    <div>
      {subsidies &&
        reimbursementsList &&
        (hasMultipleCategories ? (
          <MultipleCategoriesReimbursementsLists
            reimbursementsList={reimbursementsList}
            subsidies={subsidies}
            onTransactionClick={onTransactionClick}
          />
        ) : (
          <SingleCategoryReimbursementsList
            reimbursementsList={reimbursementsList}
            subsidy={subsidies[0]}
            onTransactionClick={onTransactionClick}
          />
        ))}
    </div>
  )
}

export default ReimbursementsList
